// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__1ZdFo","card":"Cards_card__2cQ-o","cardTitle":"Cards_cardTitle__2to0S","count":"Cards_count__3x6T6","lastupdate":"Cards_lastupdate__2E_F-"};